import styled from 'styled-components';
import {
  getGridSpan,
  gridContainer,
  setGridColumns,
  getGridSpans,
  getSpace,
  mq,
  px2rem
} from '../../../stylesheets/tools';

const dotsTransition = '/static/dots/background-dots-white.svg';
const dotsTopicTransition = '/static/dots/dots-pink.svg';

const StyledStage = styled.section`
  overflow: hidden;

  .stage__intro-cooperation {
    margin-bottom: ${getSpace('m')};

    .stage__intro-cooperation-logo {
      max-width: 200px;
      max-height: 60px;
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: left center;
    }
  }

  .stage__hero-background {
    height: 80vh;
    display: flex;
    position: relative;
  }

  .stage__hero-image {
    object-fit: cover;
    width: 100%;
  }

  .stage__hero-dots {
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 170px;
    background-size: 231px 170px;
    background-repeat: repeat;
    -webkit-transform: scaleY(-1) rotate(180deg);
    -ms-transform: scaleY(-1) rotate(180deg);
    transform: scaleY(-1) rotate(180deg);
    background-image: url(${dotsTransition});
  }

  .stage__content {
    z-index: 5;
    position: relative;
    margin-top: -16rem;

    ${mq('m')} {
      margin-top: -26rem;
    }
  }

  .stage__container {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    max-width: 83.75rem;
    margin-left: auto;
    margin-right: auto;
    padding-bottom: ${getSpace('xl')};

    ${mq('m')} {
      padding-bottom: ${getSpace('xxxl')};
    }
  }

  .stage__intro {
    ${getGridSpans('width', { s: 12, m: 7 })}
    padding-right: ${px2rem('40px')};

    ${mq('m')} {
      padding-right: ${px2rem('80px')};
    }
  }

  .stage__intro-container {
    position: relative;
    background: white;

    ${mq('m')} {
      min-height: ${px2rem('400px')};
    }
  }

  .stage__intro-content {
    position: relative;
    padding: ${px2rem('24px')};

    ${mq('m')} {
      padding: ${px2rem('60px')} ${px2rem('30px')} ${px2rem('60px')} ${px2rem('46')};
    }
    z-index: 5;
  }

  .stage__subline {
    margin-bottom: ${getSpace('m')};
  }

  .stage__introduction {
    width: ${getGridSpan('11', 'normal')};
    margin: ${getSpace('m')} 0;

    ${mq('m')} {
      width: ${getGridSpan('10', 'normal')};
    }
  }

  .stage__credits {
    margin-top: ${getSpace('m')};
  }

  .stage__intro-content-border {
    position: absolute;
    right: 0;
    top: 0;
    background-color: #ffffff;
    height: 100%;
    width: 100vw;
  }

  .stage__intro-content-border:before {
    content: '';
    position: absolute;
    clip-path: polygon(100% calc(100% - 2px), 100% 100%, 0 100%, 0 0);
    background: #fff;
    width: 100%;
    top: ${px2rem('-59px')};
    height: ${px2rem('60px')};

    ${mq('m')} {
      top: ${px2rem('-89px')};
      height: ${px2rem('90px')};
    }
  }

  .stage__intro-content-border:after {
    content: '';
    position: absolute;
    clip-path: polygon(2px 0, 100% 50%, 2px 100%, 0 100%, 0 0);
    background: #fff;
    right: ${px2rem('-59px')};
    width: ${px2rem('60px')};
    height: 100%;
    max-height: 600px;

    ${mq('m')} {
      right: ${px2rem('-79px')};
      width: ${px2rem('80px')};
    }
  }

  .stage__event {
    display: flex;
    ${getGridSpans('width', { s: 12, m: 5 })};
    padding: ${px2rem('24px')};
    max-width: ${px2rem('460px')};
    ${mq('m')} {
      padding: 0 ${px2rem('24px')} 0 0;
    }
  }

  .teaserContainer__teaser {
    width: 100%;
    margin-top: auto;
    margin-bottom: 0px;
    border: 2px solid;
    background: #ffffff;
    margin-left: 0;
  }

  &.stage--secondary {
    display: flex;
    flex-direction: column;

    .stage__intro-content-border {
      display: none;
    }
    .stage__intro-container {
      background: none;
    }
    .stage__hero-background {
      height: 30vh;
      ${mq('m')} {
        height: 100vh;
      }

      &::after {
        display: block;
        width: 100%;
        height: 100%;
        background: linear-gradient(180deg, #badde3 0%, #e6f4f5 25.25%);
        clip-path: polygon(0% 33%, 0% 0%, 100% 0%, 100% 100%, 90% 100%, 70% 70%);
        content: '';
        position: absolute;
        z-index: -1;

        ${mq('m')} {
          clip-path: polygon(33% 0%, 100% 0%, 100% 100%, 90% 100%, 52% 50%);
        }
      }
    }
    .stage__hero-dots {
      height: 3vh;
      background-size: 131px 50px;
      ${mq('m')} {
        height: 170px;
        background-size: 231px 170px;
      }
    }

    .stage__content {
      margin-top: 0;
      ${mq('m')} {
        margin-top: -100vh;
        height: 100vh;
        padding-top: 20vh;
      }
    }

    .stage__hero-image {
      object-fit: contain;
      object-position: bottom right;
      margin-left: auto;
      ${mq('m')} {
        object-position: right;
        max-width: 65vw;
      }
    }
  }

  .stage__topic-grid {
    padding: ${getSpace('l')} 0;
    ${gridContainer()}
    ${setGridColumns('1fr', 1, {
      m: ['1fr', 7]
    })}
    gap: ${px2rem('40px')};
    align-items: center;

    ${mq('m')} {
      padding: ${getSpace('xxl')} 0;
      gap: ${px2rem('80px')};
    }
  }

  .stage__topic-image-container {
    position: relative;
    grid-column: span 1 / span 1;

    ${mq('m')} {
      grid-column: span 4 / span 4;
    }
  }

  .stage__topic-image-background {
    position: absolute;
    display: flex;
    padding-left: 30px;
    top: 0;
    height: 100%;
    width: 100%;
  }

  .stage__topic-image-bg-color {
    background-color: ${props => props.theme.siteTheme.secondary};
    height: 100%;
    width: 25%;
  }
  .stage__topic-image-bg-dots {
    background-color: ${props => props.theme.siteTheme.secondary};
    mask-image: url(${dotsTopicTransition});
    mask-size: auto 100%;
    mask-repeat: no-repeat;
    width: 75%;
    height: 100%;
    margin-left: -2px;
  }

  .stage__topic-image {
    position: relative;
    z-index: 5;
    aspect-ratio: 4 / 3;
    object-fit: cover;
    width: 100%;
    padding: ${px2rem('20px')} 0;
  }

  .stage__topic-text-container {
    grid-column: span 1 / span 1;
    ${mq('m')} {
      grid-column: span 3 / span 3;
    }
  }

  .stage__topic-headlines {
    margin-bottom: ${px2rem('20px')};

    h2 {
      margin-top: ${px2rem('15px')};
    }

    ${mq('l')} {
      margin-bottom: ${px2rem('40px')};
      padding-top: ${px2rem('20px')};
    }
  }

  .stage__topic-copy {
    margin-left: ${getGridSpan(1, 'spread')};
    ${getGridSpans('width', { m: 10 })}
  }

  .stage__topic-link {
    display: block;
    margin-top: ${getSpace('l')};

    svg {
      height: 20px;
      width: auto;
    }
  }
`;

export default StyledStage;
